import { Route } from "@angular/router";
import { PorteurAddComponent } from "./porteur-add.component";

export const PorteurAddRouting: Route = {
    path: 'add-porteur',
    component: PorteurAddComponent,
    data: {
        breadcrumb: "Ajouter un utilisateur"
    }
}
